<template>
  <div class="form_line" id="ort_wrapper" :class="{ loading: loading}">
    <label for="ort"
      >Ort
      <div class="comment">
        Bitte geben Sie einen genauen Straßennamen, Bezirk, oder PLZ an.
      </div>
    </label>
    <span class="p-input-icon-right">
      <Clearer v-model="ort" />
      <InputText v-model="ort" id="ort" type="text" placeholder="Ganz Berlin"/>
    </span>
    <div class="error" v-if="noResults">Keine Ergebnisse gefunden!</div>
    <Button
      label="Adresse suchen"
      @click.prevent="searchAddress"
      id="adressesuchen"
      :disabled="adressesucheDisabled"
      v-if="addressButEnabled"
    />
  </div>

  <div class="form_line" v-if="showDropdown">
    <Dropdown v-model="address" :options="addresses" optionLabel="name">
      <template #option="slotProps">
        <div v-if="slotProps.option.headerOption" class="option headerOption">
          <span>{{ slotProps.option.name }}</span>
        </div>
        <div v-else class="option normalOption">
          <span>{{ slotProps.option.name }}</span>
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import getAddresses from "@/composables/getAddresses";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Clearer from "@/components/Clearer";
import { ref, watchEffect, watch, onMounted } from "vue";

export default {
  components: {
    Dropdown,
    InputText,
    Clearer,
    Button,
  },
  props: ["clear"],
  emits: ["loc-changed","update-can-search"],
  setup(props, { emit }) {
    const ort = ref(props.ort);
    const adressesucheDisabled = ref(true);
    const address = ref("");
    const showDropdown = ref(false);
    const addressButEnabled = ref(true);
    const canSearch = ref(true);
    const noResults = ref(false);
    const isGeoCoords = ref(false);
    const inSearch = ref(false);
    const loading = ref(false);
    const { loadAddress, addresses } = getAddresses();
    const defaultAddress = ref({
      coords: "13.404954,52.520008",
      dist: 25,
    });

    address.value = defaultAddress.value;

    const searchAddress = () => {
      loading.value = true;
      loadAddress(ort.value, () => {
        if(addresses.value.length){
          address.value = addresses.value[0];
          canSearch.value = true;
          noResults.value = false;
        }else{
          canSearch.value = false;
          noResults.value = true;
        }
        loading.value = false;
      });
    };

    watch(
      () => props.clear,
      (selection, prevSelection) => {
        if (selection !== prevSelection) {
          ort.value = "";
          address.value = defaultAddress.value;
          noResults.value = false;
        }
      }
    );

    watch(
      () => ort.value,
      (selection, prevSelection) => {
        if(selection !== prevSelection){
          noResults.value = false;
        }
      }
    );

    watchEffect(() => {
      // Toggle Adresse Suchen But
      if (ort.value && ort.value.trim().length) {
        adressesucheDisabled.value = false;
      } else {
        adressesucheDisabled.value = true;
        canSearch.value = true;
        addresses.value = [];
      }

      // If no addresses, hide dropdown and use default address
      if (addresses.value.length) {
        showDropdown.value = true;
      } else {
        showDropdown.value = false;
      }

      // Catch for Geocoords
      if (ort.value && ort.value.trim().length) {
        if (ort.value.match(/^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/)) {
          addressButEnabled.value = false;
          let coordsUp = ort.value.trim().split(",");
          address.value = {
            coords: coordsUp[1].trim() + "," + coordsUp[0].trim(),
            dist: 5,
          };
          isGeoCoords.value = true;
          noResults.value = false;
        } else {
          addressButEnabled.value = true;
          isGeoCoords.value = false;
        }
      }

      // If ortfield has a value, is not geocodes, and no address is chosen - disable search
      if (
        ort.value &&
        ort.value.trim().length &&
        !addresses.value.length &&
        !isGeoCoords.value
      ) {
        canSearch.value = false;
      } else {
        canSearch.value = true;
      }

      emit("loc-changed", address);
    });

    watch(
      () => canSearch.value,
      (selection, prevSelection) => {
        if (selection !== prevSelection) {
          emit("update-can-search", canSearch.value)
        }
      }
    );

    onMounted(() => {
      emit("loc-changed", defaultAddress);
      let url = new URL(window.location);
      if (url.searchParams.get("loc")) {
        ort.value = url.searchParams.get("loc");
      }
    });

    return {
      ort,
      addresses,
      adressesucheDisabled,
      searchAddress,
      address,
      showDropdown,
      addressButEnabled,
      canSearch,
      noResults,
      loading
    };
  },
};
</script>

<style>
</style>